(function() {
    $(document).ready(function() {

        $('.mod24SecondaryCta form').on('submit', function(e) {

            const submitPrimaryTeaser = $(this).data('submit-primary-teaser');

            if (submitPrimaryTeaser === 'yes') {

                e.preventDefault();

                $('.mod24ac form').first().trigger('submit');

                setTimeout(function() {

                    $('html').stop().animate({
                        'scrollTop': 0,
                    });

                }, 500);
            }
        });
    });
})();
